import { Suspense, lazy } from 'react'

import type { Event } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'
import { Modal, ModalProps } from '@tribeplatform/react-ui-kit/Modal'

import { FallbackLoading } from '../../common/components/FallbackLoading.js'
import { useI18n } from '../../i18n/providers/I18nProvider.js'

const EventAnalytics = lazy(() =>
  import('./EventAnalytics.js').then(m => ({ default: m.EventAnalytics })),
)

export interface EventAnalyticsModalProps extends ModalProps {
  event: Event
  linkToContent?: boolean
}

export const EventAnalyticsModal = ({
  event,
  linkToContent = true,
  ...props
}: EventAnalyticsModalProps) => {
  const { Link } = useRouter()
  const { $t } = useI18n()

  return (
    <Modal {...props} size="2xl">
      <div className="bg-background">
        <Modal.Header
          title={$t({
            id: 'Event.Analytics',
            defaultMessage: 'Event analytics',
          })}
          description={
            linkToContent ? (
              <Link href={event?.relativeUrl} variant="accent" target="_blank">
                {event?.title ?? ''}
              </Link>
            ) : (
              (event?.title ?? '')
            )
          }
        />
        <Modal.Content>
          <Suspense fallback={<FallbackLoading />}>
            <EventAnalytics event={event} />
          </Suspense>
        </Modal.Content>
      </div>
    </Modal>
  )
}
